export default __webpack_public_path__ + "static/media/InstrumentSans-Bold.d960bc08.woff2";